import styled from 'styled-components';

export const StyledModal = styled.div`
	width: 90%;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	z-index: 40;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	box-shadow: 0px 1px 10px #999;
	background-color: ${({ theme }) => theme.colors.background};

	.modal__header {
		display: flex;
		justify-content: flex-start;
		color: ${({ theme }) => theme.colors.text};
		padding: 0px 20px 0px 20px;
		max-width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		word-wrap: break-word;
		&__title {
			margin-block-start: 1em;
			margin-block-end: 1em;
		}
	}
	.modal__content {
		display: flex;
		justify-content: flex-start;
		color: ${({ theme }) => theme.colors.text};
		padding: 0px 20px 10px 20px;
		text-align: left;
		flex-wrap: nowrap;
	}
	.modal__action {
		display: flex;
		justify-content: space-between;
		padding: 20px 20px;
		.modal__cancel {
			color: ${({ theme }) => theme.colors.text};
			&:hover {
				color: ${({ theme }) => theme.colors.error};
				font-weight: bold;
				font-size: 18px;
			}
		}
		.modal__valid {
			color: ${({ theme }) => theme.colors.secondary};
			&:hover {
				color: ${({ theme }) => theme.colors.primary};
				font-weight: bold;
				font-size: 18px;
			}
		}
	}
`;

export const StyledLoadingContainer = styled.div`
	background-color: ${({ theme }) => theme.colors.background};
	position: absolute;
	display: flex;
	height: 100%;
	width: 100%;
	justify-content: center;
	align-items: center;
	z-index: 10;
	& > svg > .circle {
		stroke: ${({ theme }) => theme.colors.primary};
	}
`;
